import { render } from "./Tasks.vue?vue&type=template&id=70112a24"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Farmer/Partials/Tasks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70112a24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70112a24', __exports__)) {
    console.log('reload')
    api.reload('70112a24', __exports__)
  }
  
  module.hot.accept("./Tasks.vue?vue&type=template&id=70112a24", () => {
    console.log('re-render')
    api.rerender('70112a24', render)
  })

}


export default __exports__